import entries from "lodash.topairs";
import get from "lodash.get";
import fromPairs from "lodash.frompairs";

import {
  endOfDay,
  maxDateSymbol,
  minDateSymbol,
  cloneIfValidElseNow
} from "./dates";

export const prefixed = prefix => {
  return action => action.type.includes(prefix, 0);
};

export const createTypesFor = (domain, prefixObj) => {
  return entries(prefixObj).reduce((obj, [type, prefix]) => {
    return { ...obj, [type]: `${prefix}${domain}` };
  }, {});
};

export const defaultPropFunction = (...args) => {
  console.trace(
    `%c⚠️ Using default prop function. You should pass a real function\nArgs: ${args}`,
    "background: #fffad1; color: #5e5300"
  );
};

export const sanitizeWorkitemFields = fields => {
  const lastRegField = fields.find(x => x.key === "dLastReg");
  const lossDateField = fields.find(x => x.key === "dLossDate");

  if (lastRegField)
    lastRegField[maxDateSymbol] = cloneIfValidElseNow(
      get(lossDateField, "value")
    );
  if (lossDateField && lastRegField) {
    lossDateField[minDateSymbol] = cloneIfValidElseNow(
      get(lastRegField, "value")
    );
    lossDateField[maxDateSymbol] = endOfDay();
  }

  return fields.map(field => {
    if (field.type !== "Date") return field;

    if (field.key === "dLastReg") {
      return lastRegField;
    }
    if (field.key === "dLossDate") {
      return lossDateField;
    }

    return {
      ...field,
      [maxDateSymbol]: endOfDay()
    };
  });
};

export const getFieldByKey = (fieldArray, fieldKey) =>
  fieldArray.find(x => x.key === fieldKey);

const _isEmptyProp = val =>
  typeof val === "string" ? val.trim().length < 1 : val === undefined;
export const removeEmptyProps = object => {
  return fromPairs(entries(object).filter(([_, val]) => !_isEmptyProp(val)));
};

export const isNotEmptyString = val =>
  typeof val === "string" && val.trim().length;

export const kFormatter = num => {
  return Math.abs(num) > 999
    ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
    : Math.sign(num) * Math.abs(num);
};

export const obfuscateAmount = text => (text ? text.replace(/\d/g, "8") : "");

export const getWorkItemType = workItem => {
  const typeField = get(
    workItem,
    "dualFeesResponse[0].fields.fieldDetails",
    []
  ).find(field => field.key === "cOwnerRet");

  if (!typeField) return null;

  return typeField.value === "No"
    ? "insurer"
    : typeField.value === "Yes"
    ? "owner"
    : "dual";
};
